<section class="empresa-shell" aria-labelledby="empresa-shell-title">
  <h1 id="empresa-shell-title" class="empresa-shell-heading">Empresa</h1>

  <div class="empresa-shell-frame">
    <nav class="empresa-nav" aria-label="Subsecciones de empresa">
      <mat-nav-list class="empresa-mat-nav" [disableRipple]="true">
        <ng-container *ngFor="let item of navItems; let idx = index">
          <a
            *ngIf="item.route; else externalEmpresaNavItem"
            mat-list-item
            [disableRipple]="true"
            [routerLink]="item.route"
            routerLinkActive="empresa-nav-tab--active"
            [routerLinkActiveOptions]="{ exact: true }"
            [ngClass]="['empresa-nav-tab', 'empresa-nav-row-' + (idx + 1)]">
            <span matLine class="empresa-nav-tab-title">{{ item.label }}</span>
            <span matLine class="empresa-nav-tab-desc">{{ item.desc }}</span>
          </a>
          <ng-template #externalEmpresaNavItem>
            <a
              mat-list-item
              [disableRipple]="true"
              [href]="item.href"
              [ngClass]="['empresa-nav-tab', 'empresa-nav-row-' + (idx + 1)]">
              <span matLine class="empresa-nav-tab-title">{{ item.label }}</span>
              <span matLine class="empresa-nav-tab-desc">{{ item.desc }}</span>
            </a>
          </ng-template>
        </ng-container>
      </mat-nav-list>
    </nav>

    <mat-card class="empresa-shell-main radius4 empresa-mat-card-panel">
      <mat-card-content>
        <div class="empresa-router-host" [@routeAnimations]="prepareRoute(outlet)">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <section class="empresa-cta-ayuda" aria-label="Contacto y ayuda">
    <app-rackeo-cta-contact></app-rackeo-cta-contact>
  </section>
</section>
